import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from "@air/primitive-button";
import Link from "next/link";
import { NextSeo } from "next-seo";
import { memo } from "react";
import { AppErrorBackground } from "~/components/AppError/AppErrorBackground";
import { Animated404 } from "~/components/NotFound/Animated404";
import { I18n } from "~/constants/I18n";
import { Routes } from "~/constants/routes";
import { NOT_FOUND_CONTENT } from "~/constants/testIDs";
export const NotFound = /*#__PURE__*/ memo(()=>/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(NextSeo, {
                title: I18n.notFoundPageTitle,
                description: I18n.notFoundPageDescription
            }),
            /*#__PURE__*/ _jsxs(AppErrorBackground, {
                children: [
                    /*#__PURE__*/ _jsx(Animated404, {}),
                    /*#__PURE__*/ _jsx("h1", {
                        className: "text-center text-16 font-normal text-grey-11",
                        children: I18n.notFoundPageTitle
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "mb-3 text-center text-12 text-grey-8",
                        "data-testid": NOT_FOUND_CONTENT,
                        children: I18n.notFoundPageDescription
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        asChild: true,
                        size: "extra-large",
                        color: "grey",
                        children: /*#__PURE__*/ _jsx(Link, {
                            href: Routes.media.all,
                            children: "Go to Air"
                        })
                    })
                ]
            })
        ]
    }));
NotFound.displayName = "NotFound";
